import { useAuth } from "../contexts/AuthProvider";

/**
 * Check if the current user can manage master data (create/edit).
 * Only Head Office users (loc_remote === 1) can manage masters.
 * Other branch users (loc_remote === 0) are in view-only mode.
 */
export const useCanManageMasters = (): boolean => {
    const { user } = useAuth();
    const activeBranch = user?.active_branch;

    // If no user or no active branch, deny access
    if (!activeBranch) {
        return false;
    }

    // pos_loc.loc_remote = 1 for Head Office; 0 for all other branches.
    const isHeadOfficeFlag = Number(activeBranch.loc_remote) === 1;
    const branchCode = String(activeBranch.loc_code ?? user?.active_branch_id ?? "").trim().toUpperCase();
    const branchDescription = String(activeBranch.loc_desc ?? "").trim().toLowerCase();

    return isHeadOfficeFlag && (branchCode === "LC001" || branchDescription === "head office");
};
